export const isQuestionAnswered = (question, answer) => {
  if (!question || !question.id) {
    return false;
  }

  if (question.type === "multiple_check") {
    return Array.isArray(answer) && answer.length > 0;
  }

  if (question.type === "single_button") {
    return answer !== undefined && answer !== null && answer !== "";
  }

  if (question.type === "single_text") {
    return answer !== undefined && answer !== null && answer !== "";
  }

  return answer !== undefined && answer !== null && answer !== "";
};

export const getFormConfigState = (
  formConfig,
  form_found,
  form_already_submitted,
  ya_fue_completado,
  completed,
  currentIndex,
  totalPages,
  formSubmitted = false
) => {
  // Si no hay configuración, no mostrar nada
  if (!formConfig) return null;

  // Si el formulario no se encontró, mostrar pantalla de error
  if (form_found === false) {
    // Si hay configuración específica para form-not-found, usarla
    if (formConfig?.config?.["form-not-found"]) {
      return formConfig.config["form-not-found"];
    }

    // Si no hay configuración, crear una pantalla de error por defecto
    return {
      body: {
        hero: "Formulario No Encontrado",
        body: "Lo sentimos, no pudimos encontrar el formulario que estás buscando. Por favor, verifica la URL o contacta al administrador.",
        button: {
          display: true,
          label: "Cerrar",
          action: "close",
        },
        fito: {
          display: true,
          message: "¡Ups! Algo salió mal",
          emotion: "surprised",
        },
      },
      footer: {
        image: "just-wave",
      },
    };
  }

  // Si el formulario ya fue enviado o completado, mostrar pantalla de confirmación
  if (
    form_already_submitted === true ||
    ya_fue_completado === true ||
    completed === true ||
    formSubmitted === true
  ) {
    // Si hay configuración específica para form-already-sent, usarla
    if (formConfig?.config?.["form-already-sent"]) {
      return formConfig.config["form-already-sent"];
    }

    // Si no hay configuración, crear una pantalla de éxito por defecto
    return {
      body: {
        hero: "¡Formulario Enviado Exitosamente!",
        body: "Gracias por completar el formulario. Hemos recibido tu información correctamente.",
        button: {
          display: true,
          label: "Cerrar",
          action: "close",
        },
        fito: {
          display: true,
          message: "¡Excelente trabajo!",
          emotion: "happy",
        },
      },
      footer: {
        image: "just-wave",
      },
    };
  }

  // Si estamos en el índice -1 (antes de empezar), mostrar pantalla de bienvenida
  if (currentIndex === -1) {
    // Si hay configuración específica para welcome, usarla
    if (formConfig?.config?.["welcome"]) {
      return formConfig.config["welcome"];
    }

    // Si no hay configuración, crear una pantalla de bienvenida por defecto
    return {
      body: {
        hero: "Bienvenido al Formulario",
        body: "Estás a punto de comenzar a completar el formulario. Por favor, asegúrate de tener toda la información necesaria a mano.",
        button: {
          display: true,
          label: "Comenzar",
          action: "continue",
        },
        fito: {
          display: true,
          message: "¡Vamos a empezar!",
          emotion: "happy",
        },
      },
      footer: {
        image: "just-wave",
      },
    };
  }

  // Si hemos completado todas las páginas, mostrar pantalla de agradecimiento
  if (currentIndex >= totalPages && totalPages > 0) {
    // Si hay configuración específica para thank-you, usarla
    if (formConfig?.config?.["thank-you"]) {
      return formConfig.config["thank-you"];
    }

    // Si no hay configuración, crear una pantalla de agradecimiento por defecto
    return {
      body: {
        hero: "¡Gracias por Completar el Formulario!",
        body: "Has completado todas las páginas del formulario. Ahora puedes enviar tus respuestas.",
        button: {
          display: true,
          label: "Enviar",
          action: "continue",
        },
        fito: {
          display: true,
          message: "¡Casi terminamos!",
          emotion: "happy",
        },
      },
      footer: {
        image: "just-wave",
      },
    };
  }

  // Si form_found es null, significa que aún no se ha cargado el estado
  if (form_found === null) {
    return null;
  }

  // Si llegamos aquí, estamos en una página válida del formulario
  // Retornamos null para que se muestren las preguntas
  return null;
};

export const normalizeOptions = (options = []) =>
  options.map((opt, index) =>
    typeof opt === "string"
      ? { id: String(index), label: opt, value: opt }
      : opt
  );

const QuestionType = {
  TEXT: "single_text",
  CHECKBOX: "multiple_check",
  RADIO: "single_button",
};

export default QuestionType;
